
import TableList from "@components/templates/tablelist";
import comUpdate from "./update.vue";
import mixin from "./mixin";
import {
    HttpGetPlanParamList,
    HttpGetPersonList
} from "@/service/purchase/purchase.js";
import { mapState, mapGetters } from "vuex";
export default {
    mixins: [TableList, mixin],
    components: {
        comUpdate
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
            },
            Searchs: {
                show: true,
                labelWidth: 100,
            },
            datename: '',
            datetime: '',
            Plugins: { show: true },
            initData: '',
            personlist: [],
            buyerlist: [],
        };
    },
    created() {
        HttpGetPersonList({ type: 1 }).then(res => {
            let arr1 = res.data.map(item => {
                return {
                    label: item.userName,
                    value: item.userName
                }
            })
            this.personlist = [{ label: '无', value: '--' }, ...arr1]
        })
        HttpGetPersonList({ type: 2 }).then(res => {
            let arr2 = res.data.map(item => {
                return {
                    label: item.userName,
                    value: item.userName
                }
            })
            this.buyerlist = [{ label: '无', value: '--' }, ...arr2]
        })
    },
    methods: {
        // ajaxRequest: HttpGetSupplierProduct,
        ajaxRequest: HttpGetPlanParamList,
        interceptRequest(params) {
            return this.handleParams(params);
        },
        handleParams(params) {
            console.log('needComplete', params.search.needComplete)
            if (params.search.needComplete === false) {
                params.search = {};
                delete this.formData.search.needComplete;

                this.$refs.compSearchs.formData = {};
                this.$refs.compSearchs.handleShowSearch(this.$refs.compSearchs.formData);
            }
            else if (params.search.needComplete === true) {
                delete params.search.needComplete;
                params.search = {
                    ...params.search,
                    EQ_productStatus: 1,
                    EQ_replenishmentStatus: 0,
                    EQ_isPerfect: 0
                }
                this.$refs.compSearchs.formData = {
                    ...this.$refs.compSearchs.formData,
                    EQ_productStatus: 1,
                    EQ_replenishmentStatus: 0
                };
                this.$refs.compSearchs.handleShowSearch(this.$refs.compSearchs.formData);
            }

            if (params.search.EQ_checksku == true) {
                params.search.EQ_inventory = '--';
            }
            // if(params.search.EQ_checksku == false){
            //     params.search.EQ_inventory = '';
            // }
            delete params.search.EQ_checksku;
            return params;
        },
        toolsRender() { //自定义工具行
            return (
                <div class="back-fff padding-10 margin-bottom-10">
                    <Button type="success" class="margin-right-15" nativeOnClick={this.handleOperates.bind(this, '', 'batchImport')}>{this.$t('fbb.alloment.muti_import', { defaultValue: '批量导入' })}</Button>
                    <Button type="info" class="margin-right-15" nativeOnClick={this.handleOperates.bind(this, '', 'importbuyer')}>{this.$t('erp.planparam.import_buyer', { defaultValue: '导入采购员' })}</Button>
                    <Button type="primary" class="marigin-right-15" nativeOnClick={this.handleOperates.bind(this, '', 'importSafty')}>{this.$t('erp.planparam.import_safety_stock', { defaultValue: '导入安全库存' })}</Button>
                    <Button type="primary" class="pull-right margin-right-15" nativeOnClick={this.handleOperates.bind(this, '', 'exportQuery')}>{this.$t('global.common.operation_filter_export', { defaultValue: '查询条件导出' })}</Button>
                </div>
            );
        },
        exportQuery() {
            let searchData = this.handleParams(this.formData);
            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/inventoryPlan/export", {
                ...searchData
            }, {
                executor: 'request',
                download: true,
            }).catch(err => {
                this.$VMessage.error(err.message);
            })
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.selectdata', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "query":
                    this.operate = {
                        title: this.$t('global.common.operation_see', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "comUpdate",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break
                // 批量导入
                case 'batchImport':
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.alloment.muti_import', { defaultValue: "批量导入" }),
                        width: 460,
                        showFooter: false,
                        data: {
                            type: 1
                        },
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/inventoryPlan/import",
                        name: "excelFile",
                        component: "compUpload",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/inventoryPlan/excel", {
                                type: 1
                            }, "download")
                        }
                    }
                    break;
                case 'importbuyer':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.planparam.import_buyer', { defaultValue: "导入采购员" }),
                        width: 460,
                        showFooter: false,
                        data: {
                            type: 3
                        },
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/inventoryPlan/import",
                        name: "excelFile",
                        component: "compUpload",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/inventoryPlan/excel", {
                                type: 3
                            }, "download")
                        }
                    }
                    break;
                case 'importSafty':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.planparam.import_safety_stock', { defaultValue: "导入安全库存" }),
                        width: 460,
                        showFooter: false,
                        data: {
                            type: 2
                        },
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/inventoryPlan/import",
                        name: "excelFile",
                        component: "compUpload",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/inventoryPlan/excel", {
                                type: 2
                            }, "download")
                        }
                    }
                    break;
                case 'exportQuery':
                    this.exportQuery(params)
                    break
                case 'active':
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('fbb.accountmanage.active', { defaultValue: "启用" }),
                        width: 460,
                        params: { ids: params },
                        ajaxRequest: HttpSupplierProductActive
                    };
                    break
                case 'batchimg':
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.alloment.import_data', { defaultValue: "导入数据" }),
                        width: 530,
                        showFooter: false,
                        name: "files",
                        component: "compbatchImgUpload",
                        showdownload: 1,
                        actionurl: process.env.VUE_APP_APIURL_BOSS + '/api/v2/SupplierProduct/batchUploadPic',
                        params: { isMaster: 1 },
                        warningtitle: this.$t('erp.planparam.import_data_warning_title', { defaultValue: '图片以ERP SKU为前缀命名，中间加@，后面写产品图片的描述比如A001@主01.jpg' }),
                        formdata: [
                            {
                                span: 24,
                                label: this.$t('erp.planparam.is_main_picture', { defaultValue: '是否主图' }),
                                key: 'isMaster',
                                tag: 'vRadio',
                                props: {
                                    strict: false,
                                },
                                options: [{
                                    trueValue: 1,
                                    label: this.$t('erp.distribution.pickup', { defaultValue: '是' })
                                }, {
                                    trueValue: 0,
                                    label: this.$t('erp.distribution.nopickup', { defaultValue: '否' })
                                }]
                            },
                        ],

                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [{
                label: this.$t('global.common.operation_see', { defaultValue: '查看' }),
                show: true,
                params: id,
                operate: 'query'
            }]
        },
    },
    computed: {
        ...mapGetters('diction', ['getNewProductList', 'getAllCurrency', 'getAllSupplier', 'getNewDifferentAllProductList']),
        ...mapGetters("dictionary", [
            "getAllProductPerson",
        ]),
        getUserList() {
            return this.getAllProductPerson.filter(function (item) {
                // console.log(item)
                return item.label != "";
            });
        },
        productList() {
            return this.getNewDifferentAllProductList.map(item => {
                const bool = item.attach.flag === 3 ? 1 : 0
                return {
                    label: bool == 1 ? `<span class='color-error'>${item.label}(${this.$t('global.common.closed', { defaultValue: '已关闭' })})</span>` : `${item.label}`,
                    value: item.value,
                }
            });
        },
        productStatus() {
            return [
                {
                    label: this.$t('erp.product.available', { defaultValue: '可用' }),
                    value: 1
                },
                {
                    label: this.$t('global.common.inactive', { defaultValue: '停用' }),
                    value: 0
                }
            ]
        },
        TabsData() {
            return [
                {
                    name: this.$t('fbb.alloment.all', { defaultValue: '所有' }),
                    key: 'needComplete',
                    val: false
                }, {
                    name: this.$t('erp.planparam.need_complete', { defaultValue: '待完善' }),
                    key: 'needComplete',
                    val: true
                }
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 250px'
            return [
                {
                    label: 'ERP SKU',
                    key: 'CN_erpSku',
                    show: true,
                    // tag: 'vInput',
                    tag: 'div',
                    removeInput: true,
                    children: (h) => {
                        return h('compErpSkuInput', {
                            props: {
                                value: this.formData.search.CN_erpSku,
                                showread: "showyes"
                            },
                            on: {
                                'on-data': (row) => {
                                    this.formData.search.CN_erpSku = row.erpSku;
                                },
                            }
                        })
                    }
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    // labelWidth: 110,
                    tag: 'Select',
                    options: this.productList,
                    key: 'IN_lineId',
                    hideSearchTip: true,
                    props: {
                        multiple: true,
                        filterable: true,
                        clearable: true
                    },
                    show: true,
                },

                {
                    label: 'Planner',
                    tag: 'Select',
                    key: 'IN_planner',
                    options: this.personlist,
                    props: {
                        multiple: true,
                        clearable: true,
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: 'Buyer',
                    tag: 'Select',
                    key: 'IN_buyer',
                    options: this.buyerlist,
                    props: {
                        multiple: true,
                        clearable: true,
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('erp.product.product_status', { defaultValue: '产品状态' }),
                    tag: 'Select',
                    key: 'EQ_productStatus',
                    options: this.productStatus,
                    style: widthStyle
                },
                {
                    label: this.$t('erp.setting.goods_type', { defaultValue: '产品类型' }),
                    tag: 'Select',
                    key: 'IN_productType',
                    options: [
                        { value: 1, label: this.$t('erp.setting.goods_type_0', { defaultValue: '成品' }) },
                        { value: 2, label: this.$t('erp.setting.goods_type_1', { defaultValue: '配件' }) },
                        { value: 3, label: this.$t('erp.setting.goods_type_2', { defaultValue: '耗材' }) },
                    ],
                    props: {
                        multiple: true,
                        clearable: true,
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('erp.product.replenishment_status', { defaultValue: '补货状态' }),
                    tag: 'Select',
                    key: 'EQ_replenishmentStatus',
                    options: this.getReplenishmentStatus,
                    props: {
                        clearable: true
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('erp.product.saleslocation', { defaultValue: '销售定位' }),
                    tag: 'Select',
                    key: 'IN_saleType',
                    options: this.getSalesLocation,
                    props: {
                        multiple: true,
                        clearable: true
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('erp.planparam.purchase_type', { defaultValue: '项目采购模式' }),
                    tag: 'Select',
                    key: 'IN_purchaseType',
                    options: this.getProjectBuyList,
                    props: {
                        multiple: true,
                        clearable: true
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('erp.planparam.bu', { defaultValue: '部门' }),
                    tag: 'Input',
                    key: 'CN_bu',
                    style: widthStyle
                },
                {
                    label: this.$t('erp.planparam.check_sku', { defaultValue: '只展示目标库龄为空' }),
                    tag: 'vCheckBox',
                    key: 'EQ_checksku'
                },
                {
                    label: this.$t('erp.planparam.safety_stock', { defaultValue: "只展示安全库存为空" }),
                    tag: "vCheckBox",
                    key: "EQ_safetyStock",
                    props: {
                        trueValue: "--",
                        falseValue: null
                    }
                }
            ]
        },
        columns() {
            return [
                {
                    show: false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                }, {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 70,
                    render: this.getOperateNodes,
                }, {
                    title: 'ERP SKU',
                    width: 150,
                    render: (h, { row }) => {
                        return (
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.erpSku}</a>
                            </div>
                        )
                    }
                },
                {
                    title: this.$t('erp.planparam.project_payment_type', { defaultValue: '项目/采购模式' }),
                    // width: 120,
                    render: (h, { row }) => {
                        let lineItem = this.getNewDifferentAllProductList.filter(item => {
                            return item.value === row.lineId
                        })[0];
                        let purchaseItem = this.getProjectBuyList.filter(item => {
                            return item.value === row.purchaseType
                        })[0];
                        return (
                            <div>
                                <div>{lineItem ? lineItem.label : '--'}</div>
                                <div>{purchaseItem ? purchaseItem.label : '--'}</div>
                            </div>
                        )
                    }
                },
                {
                    title: this.$t('erp.product.product_status', { defaultValue: '产品状态' }) + "/" + this.$t('erp.product.saleslocation', { defaultValue: '销售定位' }),
                    render: (h, { row }) => {
                        let productStatusItem = this.getProductStatusList.filter(item => {
                            return item.value === row.productStatus
                        })[0];
                        let saleItem = this.getSalesLocation.filter(item => {
                            return item.value === row.saleType
                        })[0];
                        return (
                            <div>
                                <div>{productStatusItem ? productStatusItem.label : '--'}/{saleItem ? saleItem.label : '--'}</div>
                            </div>
                        )

                    }
                },

                {
                    title: 'Planner',
                    width: 100,
                    key: 'planner'
                },
                {
                    title: 'Buyer',
                    width: 100,
                    key: 'buyer'
                },
                {
                    title: this.$t('erp.planparam.bu', { defaultValue: '部门' }),
                    width: 100,
                    key: 'bu'
                },
                {
                    title: 'Order Cycle Time',
                    // width: 240,
                    key: 'orderCycle',
                    width: 100
                },
                {
                    title: this.$t('erp.planparam.production_cycle', { defaultValue: '生产周期' }),
                    key: 'productionCycle',
                    width: 100
                },
                {
                    title: this.$t('erp.product.minimun_order_quantity', { defaultValue: '最小起订量' }),
                    key: 'minQuantity',
                    width: 100
                },
                {
                    title: this.$t('erp.planparam.target_inventory', { defaultValue: '目标库龄' }),
                    key: 'inventory',
                    width: 100
                },
                {
                    title: this.$t('erp.virtualstore.safeQuantity', { defaultValue: "安全库存" }),
                    key: "safetyStock",
                    width: 100
                },
                {
                    title: 'Update Time',
                    key: 'updatedAt',
                    width: 130
                }
            ];
        },

    }

};
